function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V15H12.5V0H0ZM1.25 1.25H11.25V13.75H1.25V1.25ZM2.5 4.375V5.625H3.75V4.375H2.5ZM5 4.375V5.625H10V4.375H5ZM2.5 6.875V8.125H3.75V6.875H2.5ZM5 6.875V8.125H10V6.875H5ZM2.5 9.375V10.625H3.75V9.375H2.5ZM5 9.375V10.625H10V9.375H5Z",
  fill: "#666666"
});

function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f3274dbfa793b6a16aa7aea855a0491a.svg";
export { ForwardRef as ReactComponent };